(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AccountClearingRequestsV2Controller', AccountClearingRequestsV2Controller);

    AccountClearingRequestsV2Controller.$inject = ['$scope', '$state', 'AccountClearingRequestCustom'];

    function AccountClearingRequestsV2Controller($scope, $state, AccountClearingRequestCustom) {
        var vm = this;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;

        loadAll();

        function loadAll() {
            AccountClearingRequestCustom.getAllClearanceRequests().query().$promise.then(function (result) {

                vm.accountClearingRequests = result;
            });
        }

        function findStatusStyle(status) {
            return "account-clearing-request-status-" + status;
        }

        function findStatusIcon(status) {
            if (status == "REQUESTED") {
                return "glyphicon glyphicon-hourglass";
            }
            if (status == "DONE") {
                return "glyphicon glyphicon-ok";
            }
            if (status == "UNDERWAY") {
                return "glyphicon glyphicon-eye-open";
            }

        }


    }
})();
